"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Spinner.css");

var _styles = {
  "container": "Spinner__container___1KCtq",
  "spin": "Spinner__spin___2SjjF",
  "royal-blue": "Spinner__royal-blue___2UYYL",
  "dark-navy": "Spinner__dark-navy___Atbnt",
  "emerald": "Spinner__emerald___2Hz16",
  "cream": "Spinner__cream___1xE2h",
  "small": "Spinner__small___32ho6",
  "default": "Spinner__default___249LC",
  "large": "Spinner__large___1lG7k"
};

const styles = _bind.default.bind(_styles);

const Spinner = (0, _mobxReact.observer)(({
  className,
  color,
  size,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('container', color, size), className);
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  });
});
Spinner.defaultProps = {
  size: 'default',
  color: 'royal-blue'
};
var _default = Spinner;
exports.default = _default;